import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, AppText, Row, styled, useTheme } from '@streem/ui-react';
import { useMemo } from 'react';
import { useRoomSession } from '../../../context/room_session';
import { useObservable } from '../../..';
import { map } from 'rxjs/operators';
export function UserAudioStatus({ videoController, isPipDisplay, cssClassName, }) {
    const theme = useTheme();
    const roomSession = useRoomSession();
    const [ownerUserInfo] = useObservable(roomSession.user.getUser(videoController.ownerId));
    const [audioEnabled] = useObservable(videoController.ownerIsLocalUser
        ? roomSession.media.localAudio.enabled
        : roomSession.media.remoteAudio.muted.pipe(map(muted => !muted)));
    return useMemo(() => {
        if (!ownerUserInfo) {
            return _jsx(_Fragment, {});
        }
        if (audioEnabled === undefined) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs(Info, { compact: isPipDisplay, className: cssClassName, children: [_jsx(AppIcon, { name: audioEnabled ? 'UnmutedPipIcon' : 'MutedPipIcon', color: audioEnabled ? theme.colors.white : theme.colors.red50, size: 'medium' }), !isPipDisplay && _jsx(Name, { "data-clarity-mask": "true", children: ownerUserInfo?.name })] }));
    }, [
        isPipDisplay,
        ownerUserInfo,
        audioEnabled,
        theme.colors.white,
        theme.colors.red50,
        cssClassName,
    ]);
}
const Info = styled(Row)(({ compact, theme }) => ({
    userSelect: 'none',
    color: theme.colors.white,
    position: 'absolute',
    bottom: compact ? '5px' : '10px',
    left: compact ? '5px' : '20px',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    backgroundColor: 'rgba(31, 32, 33, 0.64)',
    borderRadius: '11px',
    padding: '5px',
}));
const Name = styled(AppText)({
    userSelect: 'none',
    color: 'inherit',
    marginLeft: '5px',
    textShadow: '0px 0px 6px rgba(0, 0, 0, 0.5)',
});
//# sourceMappingURL=user_audio_status.js.map